<script lang="ts" setup>
import type { NuxtError } from '#app';
import { CfgApplicationError } from '@cfgtech/ui';

const props = defineProps<{ error: NuxtError }>();
const config = useRuntimeConfig();

const { locale, t } = useI18n();

useHead({
  htmlAttrs: {
    lang: locale.value
  },

  title: t('common.notFound.pageTitle'),

  meta: [
    {
      name: 'google-site-verification',
      content: config.app.GOOGLE_SITE_VERIFICATION,
    },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, maximum-scale=1'
    },
    {
      name: 'robots',
      content: config.app.NUXT_APP_ENVIRONMENT !== 'production' ? 'noindex' : 'all'
    }
  ],
  link: [
    {
      rel: 'icon',
      type: 'image/x-icon',
      href: '/app-logo-short.svg',
    }
  ],
});

const handleError = () => clearError({ redirect: '/' });
</script>

<template>
  <NuxtErrorBoundary class="flex h-screen flex-col">
    <div class="container flex h-full flex-col py-10">
      <pre v-if="!$t">{{ JSON.stringify(props.error, null, 2) }}</pre>

      <CfgApplicationError
        v-else
        button-classes="w-full"
        :button-label="$t('common.notFound.buttonLabel')"
        :description="$t('common.notFound.description')"
        :header="$t('common.notFound.motto')"
        header-classes="whitespace-nowrap"
        :status-code="error?.statusCode || ''"
        status-code-classes="text-gray-300"
        :title="$t('common.notFound.title')"
        title-classes="[&>b]:!text-primary"
        @error="handleError"
      >
        <template #logo>
          <AppLogo class="h-11 cursor-pointer" @click.prevent="handleError" />
        </template>
      </CfgApplicationError>
    </div>

    <AppFooter />
  </NuxtErrorBoundary>
</template>

<style lang="scss" scoped>
.page-not-found__title {
  b {
    @apply text-brand;
  }
}
</style>
